if (!customElements.get('canada-shipping-notice')) {
  customElements.define(
    'canada-shipping-notice',
    class CanadaShippingNotice extends HTMLElement {
      connectedCallback() {
        this.quantityInput = this.closest('product-info')?.querySelector('input[name="quantity"]');
        this.onQuantityChange = this.update.bind(this);
        this.quantityInput?.addEventListener('input', this.onQuantityChange);
        this.quantityInput?.addEventListener('change', this.onQuantityChange);
        this.update();
      }

      disconnectedCallback() {
        this.quantityInput?.removeEventListener('input', this.onQuantityChange);
        this.quantityInput?.removeEventListener('change', this.onQuantityChange);
      }

      update() {
        const caKnown = this.dataset.caStockKnown === 'true';
        const usKnown = this.dataset.usStockKnown === 'true';
        const variantAvailable = this.dataset.variantAvailable === 'true';
        const caStock = Number.parseInt(this.dataset.caStock, 10);
        const usStock = Number.parseInt(this.dataset.usStock, 10);
        const minimumQuantity = Number.parseInt(this.dataset.minQuantity || '1', 10) || 1;
        const requestedQuantity = Math.max(
          Number.parseInt(this.quantityInput?.value || String(minimumQuantity), 10) || minimumQuantity,
          minimumQuantity
        );
        let state = '';

        if (caKnown && usKnown && variantAvailable && Number.isFinite(caStock) && Number.isFinite(usStock)) {
          if (caStock <= 0 && usStock >= requestedQuantity) {
            state = 'us';
          } else if (caStock > 0 && caStock < requestedQuantity && usStock >= requestedQuantity - caStock) {
            state = 'split';
          }
        }

        this.querySelectorAll('[data-notice-state]').forEach((content) => {
          content.hidden = content.dataset.noticeState !== state;
        });
        this.hidden = state === '';
      }
    }
  );
}
